export default {
  //Estonian et(languagecode) EE(countrycode) Estonian / Eesti
  LandingPage: {
    intro_sub:
      'Anna pakendikäitlusele teine elu ning kaitse keskkonda.',
    title: 'Samsung Upcycle-Pakend',
    sequence1_1: 'Liitu meiega ning vähendame prügi,',
    sequence1_2:
      'tekitame jätkusuutliku keskkonna ning muudame toote pakendid kasulikeks esemeteks. Vaata allapoole ning astu esimene samm.',
    sequence2_1: 'Tutvustame Samsungi keskkonnasõbralikku pakendit',
    sequence2_2:
      'Spetsiaalselt disainitud Tootekarp, mida saab keskkonna säästlikkuse nimel taaskasutada. Meisterda tootekarp mitmeid majapidamistarbeid.',
    sequence3_1: 'Jälgi pakendile prinditud täppe',
    sequence3_2:
      'Lõika juhiste järgi pakend välja ning kokku pannes lood vinge eseme.',
    sequence4_1: 'Vali asi, mida soovid meisterdada',
    sequence4_2:
      'Vaata allapoole ning vali toote, mille pakend sul on. Siis leia erinevaid disainivõimalusi. Nüüd alusta oma teekonda soovitud eseme loomisel.',
    selectBox: 'Vali oma toote',
    moreActivity:
      "Rohkem infot Samsungi jätkusuutlikute tegevuste kohta",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitorid', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Ribakõlar', //update
    SoundbarSet01:'Ribakõlari komplekt 1',
    SoundbarSet02:'Ribakõlari komplekt 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/ee/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/ee/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/ee/sustainability/overview/',
    footer: `
    Autoriõigus© 2019-2021 Samsung Kõik õigused kaitstud.`,
  },
  ProductPage: {
    selectDesign: 'Vali loomiseks disain',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Teleri alus',
    StorageBox: 'Säilituskarp',
    MagazineRack: 'Ajaleheriiul',
    CatHouse: 'Kassimaja',
    CatTunnel: 'Kassitunnel',
    BookShelf: 'Raamaturiiul',
    DeskShelf: 'Lauapealne riiul',
    BlackRhino: 'Ohustatud loomad \n Teravmokk-ninasarvik', //update
    PolarBear: 'Ohustatud loomad \n Jääkaru', //update
    SeaTurtle: 'Ohustatud loomad \n Kilpkonn', //update
    TheRider: 'Kiikhobu', //update
    Kibe: 'Sahtlisüsteem', //update
    Tessellate: 'Riiulinurk', //update
    Twist: 'Ümar tops', //update
    AlexCouchArmTable: 'Diivani \n käetoe laud', //update
    BlastOffClubHouse: 'Mänguasja \n rakett-maja', //update
    KinokoTable: 'Kinoko laud', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postkaartide \n hoidja', //update
    SneakerRack: 'Jalatsiriiul', //update
    TheSoban: 'Soban laud', //update
    ToolBox: 'Tööriistakast', //update
    DeskStationary: 'Kirjatarvete hoidja',
    CoinBank: 'Hoiupõrsas',
    MobileScanner:'Nutitelefoni hoidik',
    TabletScanner:'Tahvelarvuti hoidik',
    PetStairs:'Lemmiklooma trepid',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'min',
    all:'ALL',
    in: 'suurustes',
    inOnly: 'vaid suuruses',
    allBoxSize: 'Kõik karbi suurused',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Juhised',
    prepare: 'Valimista ette karp',
    LetsDesign: "Disaini",
    drawParts: 'Joonista osad karbile',
    note1: 'Graafiline positsioon võib sõltuda riigist või suurusest',
    note2: 'Joonesta kõik osad esmalt karbile, et teada, kas need mahuvad',
    numberSpace: 'number = täppide vaheline ruum',
    diagonal: 'diagonaal',
    LEFT: 'VASAK (osa)',
    RIGHT: 'PAREM (osa)',
    TOP: 'ÜLEMINE (osa)',
    TOP1: 'ÜLEMINE (osa) 1',
    TOP2: 'ÜLEMINE (osa) 2',
    BACK: 'TAGUMINE (osa',
    MIDDLE: 'KESKMINE (osa)',
    MIDDLE2: 'KESKMINE (osa) 2',
    BOTTOM: 'ALUMINE (osa)',
    FRONT: 'ESIMINE (osa)',
    SIDE: 'KÜLG (osa)',
    secondSIDE: 'TEINE KÜLG (osa)',
    secondSIDE1: 'TEINE KÜLG (osa) 1',
    secondSIDE2: 'TEINE KÜLG (osa) 2',
    LEG: 'JALG (osa)', //update
    JOINT: 'ÜHENDUS (osa)', //update
    FACE: 'NÄGU (osa)', //update
    DRAWERBOTTOM: 'SAHTLI PÕHI (osa)', //update
    DRAWERSIDE: 'SAHTLI KÜLG (osa)', //update
    NOSE: 'NINA (osa)', //update
    HANDLE: 'KÄEPIDE (osa)', //update
    BOTTOMSIDE: 'ALUMINE POOL (osa)', //update
    TOPSIDE: 'ÜLEMINE POOL (osa)', //update
    WING: 'TIIB (osa)', //update
    cutAndAssemble: "Lõika & komplekteeri",
    beCareful: 'Ära vigasta end kääridega',
    cutOutParts: 'Lõika tükid välja',
    assemble: 'Pane kokku',
    Assemblyguide: 'Kokkupanemise juhend', //update
    fold: 'Voltimise näidis',
    foldGuide: 'Kasuta mööbliesemete ääri papi voltimise lihtsustamiseks',
    foldGuideDezeen:
      'Voltimise lihtsustamiseks, vajuta paar korda katkendjoonele abivahendiga', //update
    glue: 'Lisa liimi või teipi pinnale ühtlaselt', //update
    cable: 'Kasuta ühendamiseks nipukaid või nööri ', //update
    done: 'Valmis!',
    goBack: 'Tagasi avalehele',
  },
  CautionPage: {
    CAUTION: 'HOIATUS',
    needItem: 'Vajad järgmisi asju',
    children: 'Lapsed peaksid olema koos täiskasvanuga',
    mat:
      'Kriimude vältimiseks, kata põrand enne alustamist',
    doNotPutHeavyThing:
      'Meisterdatud mööbi peale ära istu, astu ega asetada raskeid esemeid',
    doNotThrow:
      'Ära viska ega löö mööblit millegi suunas, sh inimeste ja loomade',
    stayAwayFlame: 'Hoidu leekidest',
    stayAwayWater: 'Ära paiguta eset vee või niiskuse lähedale',
    mayDamaged: '*Telerikast võib olla tarne käigus viga saanud',
    companyDoestResponsible:
      '* Ettevõte ei vastuta selle töö käigus tekkinud vigastuste või rikete ees',
    cannotBeReturned:
      '* Vigase karbiga toodet ei saa tagastada põhjustel, et karp pole kvaliteetne',
    understand: 'Jah, saan aru',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Lähme roheliseks',
      text1:
        'Suuremal osal teleri pakenditel oleme kasutanud vähem paberit ja tinti, võrreldes eelnevate pakenditega, et näidata oma pühendumist jätkusuutlikkusele',
      text2:'',
      text2_special:
        '(*Ülalolev ei kehti mõndadele telerimudelitele, sh elustiili teleritele)',
      text3: 'Vali allolev nupp, et vaadata lisaks',
    },
    greenIn: {
      title: 'Lähme roheliseks telerite pakendamisel',
      subtitle1: 'Otsi tooteinformatsiooni',
      subtitle2: 'Taaskasutame keskkonnasõbralikku pakendit',
      desc: 'Otsi mudeli nime, et saada rohkem infot',
      descM: '*Tee pilt teleri mudeli numbrist',
      guide: 'Mudeli nimi',
      button: 'Tee pilt',
      button2: 'Liigu asjade tegemise juurde',
      product_info: 'Tooteinfo',
    },
    search: {
      guide: 'Otsi...',
      noResult: 'Tulemused puuduvad',
      more: 'ROHKEM',
      search: 'Otsi',
      retake: 'Otsi uuesti',
      result: 'Tulemused',
    },
    photo: {
      guide1: 'Kirjuta kasti teleri mudeli nimi',
      guide2: '(nt Q800A, UT7000, RU7100 jne)',
    },
  },
  searchCountrySelect: 'Otsimiseks vali riik'
};
